// 1. Create a reusable Marquee component outside or inside your main component
const MarqueeRow = ({ items }) => {
  if (!items || items.length === 0) return null;

  // Helper to render the track twice for the infinite effect
  const renderTrack = (animationClass) => (
    <div className={`flex gap-4 ${animationClass}`}>
      {items.map((partner, index) => (
        <div
          className="group relative border border-gray w-[174px] h-[104px] overflow-hidden flex items-center justify-center p-2 rounded-[8px] bg-white cursor-pointer"
          // Use name + index for a unique key, just in case of duplicate names
          key={`${partner.name}-${index}`}
        >
          {/* Logo: Fades out slightly on hover */}
          <img
            src={partner.partner_logo}
            alt={partner.name || "UNIVERAL Partner"}
            className="h-[100%] object-contain transition-opacity duration-300 group-hover:opacity-10"
          />
          
          {/* Name Overlay: Appears on hover */}
          <div className="absolute inset-0 flex items-center justify-center p-2 text-center transition-opacity duration-300 opacity-0 pointer-events-none group-hover:opacity-100">
            <span className="text-sm font-semibold text-gray-800 line-clamp-3">
              {partner.name}
            </span>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div className="w-[100%] flex flex-row flex-1 overflow-hidden relative">
      {renderTrack("animate-marquee1")}
      {renderTrack("ml-4 absolute animate-marquee2")}
    </div>
  );
};

export default MarqueeRow;
